if (!customElements.get('shark-montage')) {
  customElements.define('shark-montage', class extends HTMLElement {
    connectedCallback() {
      const info = this.querySelector('.shark-montage__info');
      if (!info || this.tooltipInitialized) return;
      this.tooltipInitialized = true;
      info.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        info.setAttribute('data-tooltip-dismissed', '');
        event.stopPropagation();
      });
      info.addEventListener('pointerenter', () => info.removeAttribute('data-tooltip-dismissed'));
      info.addEventListener('focusin', () => info.removeAttribute('data-tooltip-dismissed'));
    }
  });
}
